<template>
  <div id="app">
    <div class="status">
      <div class="score">Score: {{ calculatedScore }}</div>
      <div class="timer">{{ time }}s</div>
      <div class="timer">Rounds: {{ rounds }}</div>
    </div>
    <div class="flex">
      <Place title="Tens" :number="tens" :correct="correct" />
      <Place title="Ones" :number="ones" :correct="correct" />
    </div>
    <Keyboard v-model="inputNumber" @submit="check()"/>
  </div>
</template>

<script>
import Place from './components/Place.vue'
import Keyboard from './components/Keyboard.vue'

const TIME_IN_SECONDS = 10

export default {
  name: 'App',
  components: {
    Place,
    Keyboard
  },
  data() {
    return {
      score: 0,
      sounds: {},
      inputNumber: '',
      ones: -1,
      tens: -1,
      correct: false,
      timer: {},
      time: TIME_IN_SECONDS,
      rounds: 0
    }
  },
  mounted () {
    this.init()
    this.sounds.success = new Audio(require('./audio/success.mp3'))
    this.sounds.fail = new Audio(require('./audio/fail.mp3'))
  },
  methods: {
    check() {
      if(!this.inputNumber || isNaN(this.inputNumber)) { return }

      this.correct = this.inputNumber == this.calculatedNumberString
      if (this.correct) {
        this.rounds = this.rounds + 1
        this.sounds.success.play()
        this.score += 10 - this.time
        this.init()
      } else {
        this.sounds.fail.play()
        this.score -= 10 - this.time
        if(this.score < 0) { this.score = 0 }
      }
    },
    init() {
      this.inputNumber = ''
      this.tens = this.generateNumber()
      this.ones = this.generateNumber()
      this.startTimer()
    },
    generateNumber() {
      return Math.floor((Math.random() * 9) + 1)
    },
    generateRandomNumber(max) {
      return Math.floor(Math.random() * max)
    },
    startTimer() {
      this.clearTimer()
      this.timer = window.setInterval(() => {
        if(this.time > 0) {
          this.time = this.round(this.time - 0.1, 2).toFixed(1)
        } else {
          this.clearTimer()
        }
      }, 100)
    },
    clearTimer() {
      if(this.timer) { clearInterval(this.timer) }
      this.time = TIME_IN_SECONDS
    },
    round(value, places) {
      const powerOfTen = Math.pow(10, places)
      return Math.round(value * powerOfTen) / powerOfTen
    }
  },
  computed: {
    calculatedNumberString() {
      return `${this.tens}${this.ones}`
    },
    calculatedScore() {
      return Math.round(this.score * 10 / (this.rounds + 1)) 
    }
  }
}
</script>

<style>
* {
    touch-action: manipulation;
}

body {
  background: #2c3e50;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  margin: 30px auto 20px auto;
  min-width: 300px;
  max-width: 1000px;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 295px;
  margin: 0 auto;
}

.status {
  position: absolute;
  top: 0;
  height: 20px;
  line-height: 20px;
  background: purple;
  width: 100%;
  left: 0;
  font-size: 9pt;
  font-weight: bold;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

</style>
